import React, { useState } from "react";
import Swal from "sweetalert2";
import PPIDmtService from "../../../services/PPIDmtService";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaDownload,
} from "react-icons/fa";
import SideBar from "../../../components/Sidebar";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const Receipt = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const { customerMobile, wallet_data, responseData } = location.state || {};

  const data = responseData?.data || {};
  const status = responseData?.status || "PENDING";
  const message = responseData?.message || "Processing your request...";

  const getStatusIcon = (status) => {
    switch (status) {
      case "SUCCESS":
        return <FaCheckCircle size={50} color="green" />;
      case "FAILED":
        return <FaTimesCircle size={50} color="red" />;
      default:
        return <FaClock size={50} color="#ffc107" />;
    }
  };

  const getStatusTextClass = (status) => {
    switch (status) {
      case "SUCCESS":
        return "text-success fw-bold fs-5";
      case "FAILED":
        return "text-danger fw-bold fs-5";
      default:
        return "text-warning fw-bold fs-5";
    }
  };

  const getMessageTextClass = (status) => {
    switch (status) {
      case "SUCCESS":
        return "text-success fw-bold";
      case "FAILED":
        return "text-danger fw-bold";
      default:
        return "text-warning fw-bold";
    }
  };

  const handleDownloadReceipt = async () => {
    try {
      setLoading(true);
      const result = await PPIDmtService.downloadReceipt(data?.order_id);

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Transaction failed", "error");
        setLoading(false);
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const link = responseData.data?.link;
        if (link) {
          window.open(link, "_blank");
        }
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", error?.message || "Network error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-4">
      {loading && <LoadingScreen />}

      <div className="row">
        {/* Sidebar */}

        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-5">
          <div
            className="card p-4 shadow-sm"
            style={{ minHeight: "80vh", backgroundColor: "#f8f9fa" }}
          >
            <h4 className="text-center fw-bold mb-4">Money Transfer Receipt</h4>

            <div className="d-flex justify-content-center">
              <div
                className="card p-4 shadow-sm"
                style={{
                  maxWidth: "530px",
                  width: "100%",
                  borderRadius: "16px",
                  backgroundColor: "#ffffff",
                }}
              >
                {/* Top logo and status section */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="text-center flex-grow-1">
                    {getStatusIcon(status)}
                    {/* <div className={`${getStatusTextClass(status)} mt-2`}>
                      {status}
                    </div> */}
                    <div
                      className={`${getMessageTextClass(status)} fw-bold mt-1`}
                      style={{ fontSize: "16px" }}
                    >
                      {message}
                    </div>
                  </div>
                </div>

                {/* Section 1: Transaction Details */}
                {/* Recharge Details Box */}
                <div className="border rounded p-3 mb-3 bg-light">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0">Transaction Details</h6>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Sender Mobile</div>
                    <div className="fw-bold">
                      {data?.mobile_number || "N/A"}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Bank Name</div>
                    <div className="fw-bold">{data?.bank_name || "N/A"}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Beneficiary Name</div>
                    <div className="fw-bold">{data?.name || "N/A"}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Account Number</div>
                    <div className="fw-bold">
                      {data?.account_number || "N/A"}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">IFSC Code</div>
                    <div className="fw-bold">{data?.ifsc_code || "N/A"}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Transfer Mode</div>
                    <div className="fw-bold">{data?.mode || "N/A"}</div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Transfer Amount</div>
                    <div
                      className="fw-bold"
                      style={{ fontSize: "18px", color: "green" }}
                    >
                      ₹{data?.amount || "N/A"}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Customer Charges</div>
                    <div
                      className="fw-bold"
                      style={{ fontSize: "18px", color: "red" }}
                    >
                      ₹{data?.customer_charges || "N/A"}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Total Payable Amount</div>
                    <div
                      className="fw-bold"
                      style={{ fontSize: "18px", color: "red" }}
                    >
                      ₹
                      {parseFloat(data?.amount) +
                        parseFloat(data?.customer_charges)}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">Order ID</div>
                    <div className="fw-bold">{data.order_id || "N/A"}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="text-muted">RRN</div>
                    <div className="fw-bold">{data.rrn || "N/A"}</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="text-muted">Date & Time</div>
                    <div className="fw-bold">{data.timestamp || "N/A"}</div>
                  </div>
                </div>

                <li className="list-group-item d-flex justify-content-between bg-light mb-3">
                  <span className="text-success fw-bold">Commission</span>
                  <span className="fw-bold text-success">
                    ₹{data?.commercial_amount}
                  </span>
                </li>

                {/* Section 2: Balance Info */}
                {(data.opening_balance ||
                  data.debit_amount ||
                  data.closing_balance) && (
                  <div className="border rounded p-3 mb-3 bg-light">
                    <div className="d-flex justify-content-between text-center">
                      <div>
                        <div className="text-muted small">Opening Bal</div>
                        <div className="fw-bold">
                          ₹{responseData.data.opening_bal || "0.00"}
                        </div>
                      </div>
                      <div>
                        <div className="text-muted small">Amount</div>
                        <div className="fw-bold" style={{ color: "red" }}>
                          - ₹{responseData.data.debit_amount || "0.00"}
                        </div>
                      </div>
                      <div>
                        <div className="text-muted small">Closing Bal</div>
                        <div className="fw-bold">
                          ₹{responseData.data.closing_bal || "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Action Buttons */}
                <div className="d-flex gap-2 mt-2">
                  <button
                    className="btn btn-outline-secondary btn-sm w-100"
                    onClick={handleDownloadReceipt}
                  >
                    <FaDownload className="me-2" />
                    Receipt
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm w-100"
                    onClick={() =>
                      navigate("/ppi-money-transfer/sender-home", {
                        state: {
                          customerMobile: customerMobile,
                          data: wallet_data,
                        },
                      })
                    }
                  >
                    Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
